import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import * as extract from 'extractFromState';
import * as colors from 'components/common/colorConstants';
import * as actions from 'actions/CommerceWizardActions';
import * as paths from 'constants/commerceWizardPathOptions';
import * as listTypes from 'constants/infoPanelTypes';
import CWHomePage from './CWHomePage/CWHomePage';
import CWSelect from './CWSelect/CWSelect';
import CWSelectedPreviousRecommendation from './CWSelectedPreviousRecommendation/CWSelectedPreviousRecommendation';
import CWSelectedRecommendation from './CWSelectedRecommendation/CWSelectedRecommendation';

const CommerceWizard = (props) => {
  // TODO: Fix dependency array
  useEffect(() => {
    return () => {
      props.eraseRecommendationRegExFromTextInput(props.selectedTicketId);
    };
  }, []); // eslint-disable-line

  const shouldShowComponent = (component) => {
    const { commerceWizardPath, selectedPreviousRecommendation, selectedRecommendation } = props;
    if (!commerceWizardPath) {
      return false;
    }

    switch (component) {
      case 'home':
        return !commerceWizardPath.length && !selectedPreviousRecommendation && !selectedRecommendation;
      case 'previousRecommendation':
        return !!selectedPreviousRecommendation;
      case 'selectedRecommendation':
        return !!selectedRecommendation;
      case paths.CROSS_SELL_PRODUCTS:
        return commerceWizardPath.includes(paths.CROSS_SELL_PRODUCTS) && !selectedRecommendation;
      default:
        return false;
    }
  };

  const useAltHeight = () => {
    return props.listType === listTypes.COMMERCE_ON_DEMAND;
  };

  return (
    <Wrapper homeOpen={shouldShowComponent('home')} altHeight={useAltHeight()}>
      {shouldShowComponent('home') && <CWHomePage />}
      {shouldShowComponent('previousRecommendation') && <CWSelectedPreviousRecommendation />}
      {shouldShowComponent('selectedRecommendation') && <CWSelectedRecommendation />}
      {shouldShowComponent(paths.CROSS_SELL_PRODUCTS) && <CWSelect />}
    </Wrapper>
  );
};

CommerceWizard.propTypes = {
  eraseRecommendationRegExFromTextInput: PropTypes.func.isRequired,
  commerceWizardPath: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  selectedTicketId: PropTypes.string.isRequired,
  selectedPreviousRecommendation: PropTypes.string,
  selectedRecommendation: PropTypes.object,
  listType: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  commerceWizardPath: extract.extractCommerceWizardPath(state),
  selectedTicketId: extract.extractSelectedTicketIdFromState(state),
  selectedPreviousRecommendation: extract.extractCommerceWizardSelectedPreviousRecommendation(state),
  selectedRecommendation: extract.extractCommerceWizardSelectedRecommendation(state),
  listType: extract.extractInfoPanelListTypeFromState(state),
});

const mapDispatchToProps = {
  eraseRecommendationRegExFromTextInput: actions.eraseRecommendationRegExFromTextInput,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommerceWizard);

const Wrapper = styled.div`
  height: ${(props) => (props.altHeight ? 'calc(100% - 55px)' : 'calc(100% - 83px)')};
  overflow-y: auto;
  background-color: ${(props) => (props.homeOpen ? colors.lightGray14 : colors.lightGray7)};
  padding-top: 0px;
  margin-top: 0px;
`;
